import React from 'react';
import { Card, CardContent } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const GenesisSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <Tabs defaultValue="genesis" className="w-full">
          <TabsList className="grid w-full max-w-2xl mx-auto grid-cols-2 mb-12">
            <TabsTrigger value="genesis" className="text-lg">Genesis</TabsTrigger>
            <TabsTrigger value="vision" className="text-lg">Our Vision & Mission</TabsTrigger>
          </TabsList>

          <TabsContent value="genesis">
            <Card className="border-none shadow-lg">
              <CardContent className="p-8 md:p-12">
                <h2 className="text-4xl font-bold text-gray-800 mb-6">Genesis</h2>
                <div className="prose prose-lg max-w-none text-gray-600">
                  <p className="mb-4">
                    PRAYATNE was founded in 1992 to enable people to respond to and change their situation 
                    of inequality and injustice. We focus on education and awareness, community involvement 
                    and collective action as the driving force of social and economic change.
                  </p>
                  <p>
                    Our work is guided by the philosophy that a community should be viewed as a potential 
                    resource, that can be honed with the skills and knowledge that will help them to come 
                    out of the situation of deprivation.
                  </p>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="vision">
            <div className="grid md:grid-cols-2 gap-8">
              <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8">
                  <h3 className="text-3xl font-bold text-orange-600 mb-4">Vision</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Prayatne's vision is a just society in which men and women are equal. We believe that 
                    each and every person – irrespective of their sex, age, caste, class and religion – 
                    should have a life of freedom and dignity in which they enjoy all their human rights 
                    and have the opportunity to fully develop their potentials.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
                <CardContent className="p-8">
                  <h3 className="text-3xl font-bold text-orange-600 mb-4">Mission</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Our mission is to empower socio-economically vulnerable sections of the society so that 
                    they are able to address all their developmental issues in self-reliant and sustainable manner.
                  </p>
                </CardContent>
              </Card>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default GenesisSection;